import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const CreateWithRovoExperienceDismissText: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateWithRovoExperienceDismissText" */ '../src/CreateWithRovoExperienceDismissText.tsx'
			)
		).CreateWithRovoExperienceDismissText,
});
